export class GetMPAPolicyResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "mpaPolicy",
            "baseName": "mpaPolicy",
            "type": "MPAPolicy",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetMPAPolicyResponse.attributeTypeMap;
    }
    constructor() {
    }
}
